<template>
  <div v-if="!recipeint" class="chat-window-messages" :class="{notify: displayNotification}" @click="clearInterval">
    <div class="message-prompt clickable" :class="{notify: displayNotification}" v-if="!focus" @click="setFocus">
      <user-img :image="recipient.image" class="usr-img" />
      Send {{recipient.first_name}} a message <span class="unread-messages" v-if="missedCount > 0">{{missedCount}}</span>
    </div>
    <chat-window v-if="focus"  :room="room" :recipient="recipient" @dismiss="focus=false" :store="store"/>
  </div>
</template>

<script>
import chatWindow from "./chatWindow.vue";
import User from "@/services/api/authUser";
import channelManagement from "@/services/messaging/channelManagement";
import snackHub from "@/services/hubs/snackbar";
import axios from "axios";
import userImg from "@/components/userImg";

export default {
  props: ["room", "recipeint", "store", "notify"],
  components: {
    chatWindow,
    userImg
  },
  data() {
    return {
      focus: false,
      displayNotification: true,
      channel: undefined,
      missedCount: 0
    };
  },
  created() {
    this.channel = channelManagement.getChannel(this.room.id);
    this.channel.messages.subscribe(msg => {
      if (!this.focus && msg.sender_id !== User.id) {
        this.clearInterval();
        snackHub.update("You have a new message");
        this.missedCount += 1;
        this.startInterval();
      }
    });
    axios
      .get(`${process.env.VUE_APP_API_URL}coaches/messaging-rooms/info/`)
      .then(({ data }) => {
        this.missedCount = data[this.room.id] || 0;
        if (this.missedCount > 0) {
          this.startInterval();
        }
      });
  },
  methods: {
    setFocus() {
      this.missedCount = 0;
      this.clearInterval();
      this.focus = true;
    },
    startInterval() {
      this.interval = setInterval(
        () => (this.displayNotification = !this.displayNotification),
        1000
      );
    },
    clearInterval() {
      clearInterval(this.interval);
    }
  },
  computed: {
    recipient() {
      return this.room.users.find(u => u.id !== User.id);
    }
  }
};
</script>

<style lang="less">
.chat-window-messages {
  .message-prompt {
    z-index: 100;
    background-image: linear-gradient(to right, #26b8fe, #34cea9);
    bottom: 0;
    color: white;
    height: 50px;
    left: 0;
    padding: 10px 10px;
    position: fixed;
    text-align: center;
    border-top-right-radius: 5px;
    display: flex;
    justify-content: center;
    font-size: 16px;
    // align-items: center;
    .usr-img {
      margin-right: 5px;
      img {
        max-height: 25px !important;
        max-width: 25px !important;
      }
    }
    @media (min-width: 600px) {
      width: 300px;
    }
    &.notify {
      background-color: #26b8fe;
    }
  }
  &.notify {
    .chat-header {
      background-color: darkorange !important;
    }
  }
}
</style>
